
import ActivityPage from '../components/activity/ActivityPage';
import AdminPage from '../components/admin/AdminPage';
import AttendanceMomentPage from '../components/attendance/AttendanceMomentPage';
import AttendancePage from '../components/attendance/AttendancePage';
import AttendancePerformancePage from '../components/attendance/AttendancePerformancePage';
import GroupAttendancePage from '../components/attendance/GroupAttendancePage';
import ContactPage from '../components/contact/ContactPage';
import DepartmentPickerPage from '../components/department/DepartmentPickerPage';
import EmployeePage from '../components/employee/EmployeePage';
import FavoriteAddPage from '../components/favorites/FavoriteAddPage';
import FavoritesPage from '../components/favorites/FavoritesPage';
import HistoryPage from '../components/history/HistoryPage';
import Home from '../components/home/Home';
import InformationArticlePage from '../components/information/InformationArticlePage';
import InformationPage from '../components/information/InformationPage';
import ActivityManagementPage from '../components/management-activity/ActivityManagementPage';
import OrganisationManagementPage from '../components/management-organisation/OrganisationManagementPage';
import ClassPage from '../components/management-organisation/class/ClassPage';
import LicenseClassesPage from '../components/management-organisation/class/LicenseClassesPage';
import SchoolclassGroupPage from '../components/management-organisation/schoolclassGroup/SchoolclassGroupPage';
import ProgramManagementPage from '../components/management-program/ProgramManagementPage';
import ProgramPage from '../components/management-program/program/ProgramPage';
import SubprogramPage from '../components/management-program/subprogram/SubprogramPage';
import TimetableManagementPage from '../components/management-timetables/TimetableManagementPage';
import TimetableMomentsPage from '../components/management-timetables/TimetableMomentsPage';
import WebManagementPage from '../components/management-web/WebManagementPage';
import InformationManagementPage from '../components/management-web/information/InformationManagementPage';
import NewsManagementPage from '../components/management-web/news/NewsManagementPage';
import MessagesPage from '../components/messages/MessagesPage';
import AboutPage from '../components/misc/AboutPage';
import MollieReturnPage from '../components/mollie/MollieReturnPage';
import NewsArticlePage from '../components/news/NewsArticlePage';
import NewsPage from '../components/news/NewsPage';
import NotificationsPage from '../components/notifications/NotificationsPage';
import PlanningPage from '../components/planning/PlanningPage';
import PlanningMomentsPage from '../components/planning/moments/PlanningMomentsPage';
import PlanningPerformancePage from '../components/planning/performances/PlanningPerformancePage';
import ProgressActivityPage from '../components/progress/ProgressActivityPage';
import ProgressAttendancePage from '../components/progress/ProgressAttendancePage';
import ProgressOverviewPage from '../components/progress/ProgressOverviewPage';
import ProgressPage from '../components/progress/ProgressPage';
import RegisterPage from '../components/register/RegisterPage';
import RegisterPerformancesPage from '../components/register/RegisterPerformancesPage';
import RegisterSummary from '../components/register/RegisterSummary';
import ReportsPage from '../components/reports/ReportsPage';
import ScheduleDetailsPage from '../components/schedule/ScheduleDetailsPage';
import SchedulePage from '../components/schedule/SchedulePage';
import SearchClassPage from '../components/search/schoolclass/SearchSchoolclassPage';
import SearchClassResultPage from '../components/search/schoolclass/SearchSchoolclassResultPage';
import SearchStudentPage from '../components/search/student/SearchStudentPage';
import SearchStudentResultPage from '../components/search/student/SearchStudentResultPage';
import TimetablePage from '../components/timetable/TimetablePage';
import TravelCostPage from '../components/travel/TravelCostPage';
import UserInfoPage from '../components/user/UserInfoPage';

export const protectedRoutes = [
    // Base routes
    { path: "/", element: <Home /> },
    { path: "/over", element: <AboutPage /> },
    { path: "/account", element: <UserInfoPage /> },

    // Favorites
    { path: "/favorieten", element: <FavoritesPage />, requiredPage: "Favorieten" },
    { path: "/favorieten-toevoegen", element: <FavoriteAddPage />, requiredPage: "Favorieten" },

    // Information
    { path: "/informatie", element: <InformationPage />, requiredPage: "Informatie" },
    { path: "/informatie/:title/:id", element: <InformationArticlePage />, requiredPage: "Informatie" },

    // Program management
    { path: "/programmabeheer", element: <ProgramManagementPage />, requiredPage: "Programmabeheer" },
    { path: "/programmabeheer/programma/:id", element: <ProgramPage />, requiredPage: "Programmabeheer" },
    { path: "/programmabeheer/deelprogramma/:id", element: <SubprogramPage />, requiredPage: "Programmabeheer" },

    // Organisation management
    { path: "/organisatiebeheer", element: <OrganisationManagementPage />, requiredPage: "Organisatiebeheer" },
    { path: "/organisatiebeheer/klas/:id", element: <ClassPage />, requiredPage: "Organisatiebeheer" },
    { path: "/organisatiebeheer/klas/activeren", element: <LicenseClassesPage />, requiredPage: "Organisatiebeheer" },
    { path: "/organisatiebeheer/klasgroep/:id", element: <SchoolclassGroupPage />, requiredPage: "Organisatiebeheer" },

    // Timetable management
    { path: "/lesroosterbeheer", element: <TimetableManagementPage />, requiredPage: "Lesroosterbeheer" },
    { path: "/lesroosterbeheer/lesrooster/:id", element: <TimetableMomentsPage />, requiredPage: "Lesroosterbeheer" },

    // Web management
    { path: "/webbeheer", element: <WebManagementPage />, requiredPage: "Webbeheer" },
    { path: "/webbeheer/nieuws/:id", element: <NewsManagementPage />, requiredPage: "Webbeheer" },
    { path: "/webbeheer/informatie/:id", element: <InformationManagementPage />, requiredPage: "Webbeheer" },

    // Other management
    { path: "/activiteitenbeheer", element: <ActivityManagementPage />, requiredPage: "Activiteitenbeheer" },
    { path: "/medewerkerbeheer", element: <EmployeePage />, requiredPage: "Medewerkerbeheer" },

    // Messages
    { path: "/notificaties", element: <NotificationsPage />, customCheck: (_, siom) => siom.messagesEnabled },
    { path: "/berichten", element: <MessagesPage />, requiredPage: "Berichten" },

    // News
    { path: "/nieuws", element: <NewsPage />, requiredPage: "Nieuws" },
    { path: "/nieuws/:title/:date/:id", element: <NewsArticlePage />, requiredPage: "Nieuws" },

    // Planning
    { path: "/plannen", element: <PlanningPage />, requiredPage: "Plannen" },
    { path: "/plannen/uitvoering/:number/:id", element: <PlanningPerformancePage />, requiredPage: "Plannen" },
    { path: "/plannen/momenten/:id", element: <PlanningMomentsPage />, requiredPage: "Plannen" },

    // Attendance
    { path: "/presentie", element: <AttendancePage />, requiredPage: "Presentie" },
    { path: "/presentie/moment/:id", element: <AttendanceMomentPage />, requiredPage: "Presentie" },
    { path: "/presentie/uitvoering/:id", element: <AttendancePerformancePage />, requiredPage: "Presentie" },
    { path: "/groepspresentie", element: <GroupAttendancePage />, requiredPage: "Presentie" },

    // Progress
    { path: "/voortgang", element: <ProgressPage />, requiredPage: "Voortgang" },
    { path: "/voortgang/inschrijving/:name/:id", element: <ProgressActivityPage />, requiredPage: "Voortgang" },
    { path: "/voortgang/presentie", element: <ProgressAttendancePage />, requiredPage: "Voortgang" },
    { path: "/voortgang-overzicht", element: <ProgressOverviewPage />, customCheck: (pages, siom) => pages.includes("Voortgang") && siom.useMultipleDepartments },

    // Register
    { path: "/inschrijven", element: <RegisterPage />, requiredPage: "Inschrijven" },
    { path: "/inschrijven/uitvoeringen/:name/:id", element: <RegisterPerformancesPage />, requiredPage: "Inschrijven" },
    { path: "/inschrijven/overzicht/:name/:id", element: <RegisterSummary />, requiredPage: "Inschrijven" },
    { path: "/activiteit/:name/:id", element: <ActivityPage />, requiredPage: "Inschrijven" },
    { path: "/inschrijven/betaling/:id", element: <MollieReturnPage />, requiredPage: "Inschrijven" },

    // Search
    { path: "/zoeken/student", element: <SearchStudentPage />, requiredPage: "Zoeken" },
    { path: "/zoeken/student/:id", element: <SearchStudentResultPage />, requiredPage: "Zoeken" },
    { path: "/zoeken/activiteit/:name/:id", element: <ActivityPage />, requiredPage: "Zoeken" },
    { path: "/zoeken/klas", element: <SearchClassPage />, requiredPage: "Zoeken" },
    { path: "/zoeken/klas/:id", element: <SearchClassResultPage />, requiredPage: "Zoeken" },

    // Schedule
    { path: "/agenda", element: <SchedulePage />, requiredPage: "Agenda" },
    { path: "/agenda/:id", element: <ScheduleDetailsPage />, requiredPage: "Agenda" },

    // Singular routes
    { path: "/historie", element: <HistoryPage />, requiredPage: "Historie" },
    { path: "/afdeling-kiezer", element: <DepartmentPickerPage />, customCheck: (_, siom) => siom.useMultipleDepartments },
    { path: "/admin", element: <AdminPage />, requiredPage: "Admin" },
    { path: "/contact", element: <ContactPage />, requiredPage: "Contact" },
    { path: "/rapporten", element: <ReportsPage />, requiredPage: "Rapporten" },
    { path: "/reiskosten", element: <TravelCostPage />, requiredPage: "Reiskosten" },
    { path: "/rooster", element: <TimetablePage />, requiredPage: "Rooster" },
];